import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Arabic is the primary language (Saudi/GCC audience). Only an explicitly
    // English navigator/localStorage flips the UI to English.
    fallbackLng: 'ar',
    // Normalize regional codes (ar-SA → ar) and bound the set, so `i18n.language`
    // is always exactly 'ar' or 'en'. This kills the strict `=== 'ar'` mismatches
    // that made an Arabic (ar-SA) user default a report to English.
    supportedLngs: ['ar', 'en'],
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    ns: ['translation'],
    defaultNS: 'translation',
  });

i18n.on('languageChanged', (lng) => {
  const htmlElement = document.documentElement;
  const isRTL = (lng || 'ar').startsWith('ar');
  
  htmlElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  htmlElement.setAttribute('lang', lng);
  
  if (isRTL) {
    document.body.style.direction = 'rtl';
    document.body.style.textAlign = 'right';
  } else {
    document.body.style.direction = 'ltr';
    document.body.style.textAlign = 'left';
  }
});

// Set initial direction based on initial language
const initialLng = i18n.language || 'ar';
const isRTL = initialLng.startsWith('ar');
document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
document.documentElement.setAttribute('lang', initialLng);

export default i18n;